module.exports = __webpack_public_path__ + "7eefaa462fcbd1b28745d83e9ab41f95.pdf";